const workerRoutes = {
  workers: "/workers",
  workerDetails: "/workers/details/:worker_id/:action?",
  WorkerDuplicates: "/workers/duplicate/:user_id",
};

export default workerRoutes;
